import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { StoresService } from '../services/stores.service';
import { PaginationComponent } from '../common/pagination/pagination.component';
import { MatDialog } from '@angular/material/dialog';
import { ImplantsModalComponent } from 'src/app/shared/implants-modal/implants-modal.component';
import { ImplantsEditComponent } from 'src/app/shared/implants-edit/implants-edit.component';
import { FormsModule } from '@angular/forms';
import { CabinetService } from '../services/cabinet.service';
import { MarkConsumeModalComponent } from '../stores/mark-consume-modal/mark-consume-modal.component';
import { ToastMessageComponent } from 'src/app/common/toast-message/toast-message.component';
import { ResetStatusModalComponent } from '../stores/reset-status-modal/reset-status-modal.component';
import { ImpantsLowStockModalComponent } from 'src/app/shared/impants-low-stock-modal/impants-low-stock-modal.component';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [CommonModule, PaginationComponent, FormsModule, RouterLink, ToastMessageComponent],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss', '../../app.component.scss']
})
export class SearchComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  @ViewChild(ToastMessageComponent) toastMessage: ToastMessageComponent;


  public implantType = "active"; // Hardcoded implant type as requested

  public implantProducts: any = [];
  public isImplantProducts: boolean = false;

  public cabinetNamesList: any = [];
  public selectedCabinetNames: any = [];
  public isCabinetNames: boolean = false;

  public totalPages: number = 0;
  public currentPage: number = 1;
  
  public totalImplants: number = 0;

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;
  
  public expirySortValue:string = "";
  public orderBy:string = "asc";

  constructor(
    public storeService: StoresService, 
    public cabinetService: CabinetService, 
    public dialog: MatDialog, 
    public location: Location
  ){}

  ngOnInit(): void {
    this.getImplants(); 
  }

  getImplants(page: string = "", search: string = "", expiry: string = "", cabinets: Array<string> = []){
    this.storeService.findImplants(this.implantType, page, search, expiry, cabinets).subscribe(res => {
      if (res.data) {
        if (res.data.data.length !== 0) {
          this.totalImplants = res.data.total;
          this.totalPages = res.data.last_page;
          this.implantProducts = res.data.data;

          if (this.isSearch || this.isFilter) {
            this.isFilterResult = true;
          }else{
            this.isImplantProducts = true;
          }
        }else{
          this.totalImplants = 0;
          this.totalPages = 0;
          if (this.isSearch || this.isFilter) {
            this.isFilterResult = false;
          }else{
            this.isImplantProducts = false;
          }
        }
      }
    });
  }

 
  onSearchSubmit(){
    this.isSearch = true;
    this.encodedSearchInput = encodeURIComponent(this.searchInput);
    this.getImplants("", this.encodedSearchInput, this.expirySortValue, this.selectedCabinetNames);
  }

  getQueryPage(page: string){
    this.currentPage = parseInt(page);
    this.getImplants(page, this.encodedSearchInput, this.expirySortValue, this.selectedCabinetNames);
  }



  openDialog(storeId: string, implantId: string): void {
    const dialogRef = this.dialog.open(ImplantsModalComponent, {
      data: {
        storeId,
        implantId
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  openEditDialog(storeId: string, implantId: string): void {
    const dialogRef = this.dialog.open(ImplantsEditComponent, {
      data: {
        storeId,
        implantId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getImplants();
      }
    });
  }

  openConsumeDialog(storeId: string, implantId: string, productName: string): void {
    const dialogRef = this.dialog.open(MarkConsumeModalComponent, {
      data: {
        storeId,
        implantId,
        productName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.status) {
          this.toastMessage.showToast(result.message, "success", 5000);
          this.getImplants();
        }else{
          this.toastMessage.showToast(result.message, "error", 5000);
        }
      }
    });
  }

  openResetStatusDialog(storeId: string, implantId: string, productName: string): void {
    const dialogRef = this.dialog.open(ResetStatusModalComponent, {
      data: {
        storeId,
        implantId,
        productName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.status) {
          this.toastMessage.showToast(result.message, "success", 5000);
          this.getImplants();
        }else{
          this.toastMessage.showToast(result.message, "error", 5000);
        }
      }
    });
  }

  openLowStockDialog(storeId: string, productId: string): void {
    const dialogRef = this.dialog.open(ImpantsLowStockModalComponent, {
      data: {
        storeId,
        productId
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  openPopup(event: Event): void {
    event.stopPropagation();
    const popup = document.getElementById('dots-popup') as HTMLElement;
    if (popup) {
      popup.style.display = popup.style.display === 'block' ? 'none' : 'block';
    }
  }

  // Format date to show only date part
  formatDate(dateString: string): string {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      
      // Format as YYYY-MM-DD
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    } catch (error) {
      return dateString;
    }
  }

  reset(event: Event): void {
    event.stopPropagation();
    this.searchInput = '';
    this.encodedSearchInput = '';
    this.currentPage = 1;
    this.getImplants();
  }

} 